import { useLocation, useNavigate } from "react-router-dom";
import { db, auth, frbase } from "../../../src/Database_fb";
// src/Database_fb
import Modal from "react-modal";
import Box from "@mui/material/Box";
import React, { useEffect, useRef, useState } from "react";
import splashBG from "../../images/splashBG.png";
import { AiOutlineArrowLeft, AiOutlineRight } from "react-icons/ai";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Grid from "@mui/material/Grid";
import list_item_bg from "../../images/list_item_bg.png";
import clip_normal from "../../images/clip_normal.png";

Modal.setAppElement(document.getElementById("root"));
const AddContact = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { preSelected, from, networkUsers = [] } = location.state || {};
  
  const [AllAppusers, setAllAppusers] = useState([]);
  const [search, setSearch] = useState("");
  const [selectedUsers, setSelectedUsers] = useState(preSelected || []);
  useEffect(() => {
    loadAllUsers();
  }, []);

  // console.log("location.state add conts", location.state);

  function loadAllUsers() {
    var allusers = [];
    db.collection("users")
      .get()
      .then((doc) => {
        doc.forEach((document) => {
          allusers.push({ key: document.id, ...document.data() });
        });
        setAllAppusers(allusers);
      });
  }
  const filteredUsers = AllAppusers.filter(
    (user) =>
      user?.name?.toLowerCase().includes(search.toLowerCase()) ||
      user?.email?.toLowerCase().includes(search.toLowerCase())
  );

  // console.log('filteredUsers', filteredUsers)

  function searchingItem(e) {
    let text = e.target.value;
    setSearch(text);
    // if (text.length == 0) {
    //   setfilteredlibraryArray(dataItems);
    //   return;
    // }
  }

  const toggleSelection = (item) => {
    setSelectedUsers((prev) => {
      const exists = prev.some((selectedItem) => selectedItem.key === item.key);
      if (exists) {
        return prev.filter((selectedItem) => selectedItem.key !== item.key);
      } else {
        return [...prev, item];
      }
    });
  };

  // Check if all network users are selected
  const areAllNetworkUsersSelected = networkUsers.length > 0 &&
    networkUsers.every((networkUser) =>
      selectedUsers.some((selected) => selected.key === networkUser.key)
    );

  // Toggle all network users selection
  const toggleAllNetworkUsers = () => {
    setSelectedUsers((prev) => {
      if (areAllNetworkUsersSelected) {
        // Remove all network users from selection
        return prev.filter(
          (selected) => !networkUsers.some((networkUser) => networkUser.key === selected.key)
        );
      } else {
        // Add all network users that aren't already selected
        const newUsers = networkUsers.filter(
          (networkUser) => !prev.some((selected) => selected.key === networkUser.key)
        );
        return [...prev, ...newUsers];
      }
    });
  };

  return (
    <>
      <Box
        sx={{
          height: "100vh",
          width: "100%",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          paddingBottom: 15,
          backgroundImage: `url(${splashBG})`,
          backgroundRepeat: "repeat",
          backgroundColor: (t) =>
            t.palette.mode === "light"
              ? t.palette.grey[50]
              : t.palette.grey[900],
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <Box sx={{ width: "95%" }}>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Button
              onClick={() => {
                // navigate(-1);
                navigate(from, {
                  state: {
                    ...location.state, // 👈 also keep previous state
                    onSelect: null,
                  },
                });
              }}
            >
              <AiOutlineArrowLeft
                style={{
                  width: 20,
                  height: 20,

                  color: "#fff",
                }}
              />
            </Button>
            <TextField
              InputLabelProps={{
                style: {
                  fontWeight: "bold",
                  color: "#f7a828",
                },
              }}
              inputProps={{
                style: {
                  height: "5px",
                },
              }}
              placeholder={"Search by name..."}
              style={{ backgroundColor: "#fff", borderRadius: 10 }}
              fullWidth
              required
              id="search"
              name="search"
              hiddenLabel={true}
              value={search}
              onChange={(e) => searchingItem(e)}
            />

            <Button
              onClick={() => {
                console.log("555665");
                if (selectedUsers.length > 0) {
                  navigate(from, {
                    state: {
                      ...location.state, // 👈 keep previous state (like onSelect)
                      selectedContacts: selectedUsers,
                    },
                  });
                } else {
                  navigate(from, {
                    state: {
                      ...location.state, // 👈 also keep previous state
                      onSelect: null,
                    },
                  });
                }
              }}
              style={{
                paddingLeft: 20,
                paddingRight: 20,
                fontSize: 18,
                color: "lightgreen",
              }}
            >
              <p style={{}}>Done</p>
              <p style={{ marginLeft: 5 }}> ✓</p>
              {/* <input type="checkbox" checked={true} onBeforeInputCapture={false} /> */}
            </Button>
          </div>
          <div style={{ height: 20 }} />

          <Grid
            container
            //height={200}
            spacing={{ xs: 3, md: 3 }}
            columns={{ xs: 4, sm: 8, md: 12 }}
          >
            {/* Add all network users option */}
            {networkUsers.length > 0 && (
              <Grid item xs={12}>
                <div
                  onClick={toggleAllNetworkUsers}
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    borderRadius: 5,
                    height: "70px",
                    cursor: "pointer",
                    backgroundColor: "#d4a85a",
                    alignItems: "center",
                  }}
                >
                  <div
                    style={{
                      width: "15%",
                      alignItems: "center",
                      display: "flex",
                      justifyContent: "center",
                    }}
                  >
                    <div
                      style={{
                        height: 60,
                        width: 60,
                        borderRadius: 30,
                        backgroundColor: "#ffac30",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        fontSize: 24,
                      }}
                    >
                      👥
                    </div>
                  </div>
                  <div style={{ width: "80%", alignItems: "center" }}>
                    <p
                      style={{
                        fontSize: 16,
                        fontWeight: "bold",
                        color: "#000",
                        textAlign: "start",
                        marginLeft: "3%",
                      }}
                    >
                      Add all network users
                    </p>
                    <p
                      style={{
                        fontSize: 13,
                        color: "#333",
                        textAlign: "start",
                        marginLeft: "3%",
                        marginTop: -10,
                      }}
                    >
                      {networkUsers.length} user{networkUsers.length !== 1 ? 's' : ''}
                    </p>
                  </div>

                  <Box
                    style={{
                      border: 1,
                      height: 22,
                      width: 22,
                      position: "relative",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      top: 0,
                      borderRadius: 4,
                      backgroundColor: "#ffac30",
                      borderColor: "#000",
                      padding: 2,
                      right: 10,
                    }}
                  >
                    {areAllNetworkUsersSelected && <span>✓</span>}
                  </Box>
                </div>
              </Grid>
            )}

            {filteredUsers.map((prop, index) => {
              return (
                <Grid item xs={6}>
                  <div
                    onClick={() => {
                      toggleSelection(prop);
                      // console.log("selected 66678", prop);
                    }}
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      borderRadius: 5,
                      height: "70px",
                      cursor: "pointer",

                      backgroundColor: "#e6d2a5",
                    }}
                  >
                    <div
                      style={{
                        width: "15%",
                        alignItems: "center",
                        display: "flex",
                        justifyContent: "center",
                      }}
                    >
                      <img
                        style={{
                          height: 60,
                          width: 60,
                          left: 8,
                          borderRadius: 30,
                          resizeMode: "contain",
                          backgroundColor: "grey",
                        }}
                        src={
                          prop.imageUrl != ""
                            ? prop.imageUrl
                            : require("../../images/avtarImg.png")
                        }
                      />
                    </div>
                    <div style={{ width: "80%", alignItems: "center" }}>
                      <p
                        style={{
                          fontSize: 15,
                          color: "#000",
                          textAlign: "start",
                          marginLeft: "3%",
                          //marginTop: '4%'
                        }}
                      >
                        {prop.name}
                      </p>
                      <p
                        style={{
                          fontSize: 15,
                          color: "#000",
                          textAlign: "start",
                          marginLeft: "3%",
                          marginTop: -10,
                        }}
                      >
                        {prop.email}
                      </p>
                    </div>

                    <Box
                      // onClick={() =>  console.log('dfkjhdsj')}
                      style={{
                        border: 1,
                        height: 22,
                        width: 22,
                        position: "relative",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        top: 20,
                        borderRadius: 4,
                        backgroundColor: "#ffac30",
                        // border: "1px solid #000",
                        borderColor: "#000",
                        padding: 2,
                        right: 10,
                      }}
                    >
                      {" "}
                      {/* <span>✓</span> */}
                      {selectedUsers.some((i) => i.uid === prop.uid) && (
                        <span>✓</span>
                      )}
                    </Box>
                  </div>
                </Grid>
              );
            })}
          </Grid>
        </Box>
      </Box>
    </>
  );
};
export default AddContact;
